import BellTopBar from "../../../../../Components/Bars/BellTopBar";
import TableTopBar from "../../../../../Components/FinalTable/TableTopBar";
import usePouchPagination from "../../../../../Hooks/usePouchPagination";
import useFuzzySearch from "../../../../../Hooks/useFuzzySearch";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SchemesAll from "./components/context/SchemesAll";
import SchemesTable from "./components/Table";

const PouchData = ({showLive}) => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [showPagination, setShowPagination] = useState(true);
  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const db_name = "insurance_scheme";

  const initialIndex = ["created_at"];

  const initialSort = [{ created_at: "desc" }];

  const initialSelector = {
    created_at: { $gte: null },
  };

  const {
    hasNextPage,
    hasPrevPage,
    handleNext,
    handlePrev,
    handleHeaderQuery,
    handleFilterQuery,
    resetQuery,
    handleTab,
    page,
    total,
  } = usePouchPagination({
    db_name,
    limit,
    initialSort,
    initialIndex,
    initialSelector,
    setData,
    setTableIsLoading,
  });

  const searchOptions = {
    keys: ["name"],
    minMatchCharLength: 3,
    threshold: 0.5,
  };

  useFuzzySearch({
    db_name,
    input: searchInput,
    options: searchOptions,
    limit,
    setShowPagination,
    setIsFiltered,
    setTableIsLoading,
    setData,
  });

  async function handleClearFilters() {
    await resetQuery();
    setIsFiltered(false);
    setSearchInput("");
  }

  return (
    <SchemesAll.Provider
      value={{
        showLive,
        limit,
        setLimit,
        data,
        setData,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        handleClearFilters,
        total,
        setIsFiltered,
        showPagination,
        resetQuery,
        handleTab,
      }}
    >
      <div className="w-full h-full bg-ghost_white">
        <BellTopBar label={"Schemes"} />
        <div className="w-full px-6 pb-8">
          <TableTopBar
            showSearch={true}
            showFilter={false}
            showAdd={true}
            showReport={false}
            handleClearFilters={handleClearFilters}
            isFiltered={isFiltered}
            tableIsLoading={tableIsLoading}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            AddClick={() => navigate("/dashboard/schemes/add")}
            addLabel="Add Scheme"
            mt={2}
            px={2}
            mb={2}
          />

          <SchemesTable />
        </div>
      </div>
    </SchemesAll.Provider>
  );
};

export default PouchData;
